import { render, staticRenderFns } from "./MissionDetailItem.vue?vue&type=template&id=7642e624&"
import script from "./MissionDetailItem.vue?vue&type=script&lang=ts&"
export * from "./MissionDetailItem.vue?vue&type=script&lang=ts&"
import style0 from "./MissionDetailItem.vue?vue&type=style&index=0&lang=sass&"


/* normalize component */
import normalizer from "!../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  null,
  null
  
)

export default component.exports

/* vuetify-loader */
import installComponents from "!../../../../node_modules/vuetify-loader/lib/runtime/installComponents.js"
import { VCol } from 'vuetify/lib/components/VGrid';
import { VRow } from 'vuetify/lib/components/VGrid';
installComponents(component, {VCol,VRow})
